import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { helperGetRelativeUrl } from 'helpers/RouteHelper';
import CloseButton from './components/CloseButton';
import ModalImage from './components/ModalImage';
import TuneInMeta from './components/TuneInMeta';
import Title from './components/Title';
import DescriptionMeta from './components/DescriptionMeta';
import ActionButton from './components/ActionButton';
import FavoriteButton from './components/ActionButton/FavoriteButton';
import Style from './FutureCellModal.module.scss';

const FutureCellModal = ({
  favoritesManager = {},
  onClose = () => null,
  recommendationId,
  showPlayButton,
  video = {},
  visibility,
}) => {
  const { callSign, seriesName, description, images, isSeriesDetailAvailable, seriesScreenUrl } =
    video || {};
  const { raw: image } = images?.seriesList || {};
  const { global_moreInfoButton: moreInfoText } = window.Language;

  return (
    <div className={classNames([Style.container, visibility && Style.visible])} onClick={onClose}>
      <div className={Style.contents} onClick={e => e.stopPropagation()}>
        <CloseButton onClick={onClose} />
        <ModalImage callSign={callSign} image={image} showPlayButton={showPlayButton} />
        <div className={Style.infoContainer}>
          <TuneInMeta {...video} />
          <div className={Style.headerName}>{seriesName}</div>
          <Title {...video} />
          <div className={Style.description}>{description}</div>
          <DescriptionMeta {...video} />
          <FavoriteButton
            {...video}
            manager={favoritesManager}
            recommendationId={recommendationId}
          />
          <ActionButton
            shouldRender={isSeriesDetailAvailable !== false}
            url={helperGetRelativeUrl({ url: seriesScreenUrl })}
            text={moreInfoText}
            icon="info"
          />
        </div>
      </div>
    </div>
  );
};

FutureCellModal.propTypes = {
  favoritesManager: PropTypes.shape({}),
  onClose: PropTypes.func,
  recommendationId: PropTypes.string,
  video: PropTypes.shape({}),
  visibility: PropTypes.bool,
  showPlayButton: PropTypes.bool,
};

export default FutureCellModal;
